import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import scrollTo from 'gatsby-plugin-smoothscroll';

import HeroRecipe from '../../pages/recipes/mofongo-hero.png';
import downBtn from '../../media/icon-down.svg';

export class Hero extends React.Component {
    render() {
        const heroTextBlock = props => {
            return {
                // EDIT ENGLISH COPY HERE
                en: (
                    <div className="hero-intro-block">
                        <h1>
                            The flavors <nobr>that unite us.</nobr>
                        </h1>
                        <p>
                            No matter where we’re from, we all share in the flavors 
                            of tradition. Celebrate Hispanic Heritage Month with 
                            rich flavors found across the Caribbean and the 
                            Americas.
                        </p>
                    </div>
                ),
                // EDIT SPANISH COPY HERE
                es: (
                    <div className="hero-intro-block">
                        <h1>
                            Los sabores <nobr>que nos unen.</nobr>
                        </h1>
                        <p>
                            No importa de dónde seas, compartimos los sabores de 
                            la tradición. Celebra el Mes de la Herencia Hispana con 
                            ricos sabores desde el Caribe hasta las Américas.
                        </p>
                    </div>
                )
            };
        };

        return (
            <section id="hero" className="to-blur">
                <Container>
                    <Row>
                        <Col
                            sm={12}
                            md={{ span: 6, order: 12 }}
                            className="hero-image-column mb-4 mb-sm-0"
                        >
                            <img
                                src={HeroRecipe}
                                alt="Mofongo"
                                className="hero-image"
                            />
                            <img
                                src={HeroRecipe}
                                alt="Mofongo"
                                // className="hero-image"
                                id="heroSlide"
                            />
                        </Col>
                        <Col
                            sm={12}
                            md={{ span: 6, order: 1 }}
                            className="hero-intro-column fade-in"
                        >
                            {heroTextBlock()[this.props.langKey]}
                        </Col>
                    </Row>
                </Container>
                {/* Featured Recipe CTA div */}
                <div
                    className="featured-recipe-cta"
                    onClick={() => scrollTo('#featured')}
                >
                    <img src={downBtn} alt="Down Arrow" />
                    {this.props.langKey === 'en'
                        ? 'Featured Recipes'
                        : 'Recetas Destacadas'}
                </div>
            </section>
        );
    }
}

export default Hero;
